/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 8/21/19
 * Time: 11:34 AM
 */
import React from 'react'
import './styles.css'
import {connect} from "react-redux";
import * as actionCreator from "../../../store/Action/index";
import {Button, Card, CardBody, CardHeader, Col, Row} from 'reactstrap';
import LabelInput from "../../../components/Input/Input/TxtLbl";
import {MDBDataTable} from 'mdbreact'
import {Button as SementicBtn, Checkbox, Form, Icon, Input, Dropdown} from 'semantic-ui-react'
import {Spin, Tooltip, Icon as AntdIcon} from "antd";
import * as DropDownConst from "../../../store/Reducer/DropDownConst";
import DrpDwn from "../../../components/Dropdown/Dropdown/DrpDwn";
import $ from "jquery";
import * as common from "../../../const/Common/CommonFunc";
import are_you_sure_icon from "../../../assets/img/sweet/question.svg";
import swal from "sweetalert";
import Lbl from "../../../components/Label/Lbl";
import * as EmailValidator from "email-validator";
import Cookies from "js-cookie";
import axiosTags from "../../../axios/axios_tag";
import axios from "../../../axios/axios_visitortag";
import Update from "./Update/Update";
import apiConfig from "../../../axios/axios_api_services";
import IntlTelInput from "react-intl-tel-input";
import * as util from '../../../util/Validator'

class App extends React.Component {

  state = {
    email: "",
    name: "",
    username: "",
    password: "",
    branch_list: [],
    userRole: "",
    validatePassword: false,
    validEmail: false,
    isLoadSysUsers: false,
    systemusers_list: [],
    isUpdate: false,
    recept_data: null,
    status: true,
    mobile: '',
    format_mobile: '',
    valid_mobile: false,filterStatus:'ALL',
    searchType:'NIC',
    searchText:'',
    valid_search_mobile:false,
    search_mobile:'',
    searchOptions: DropDownConst.IdentificationsHostWithoutVN
  };

  loadSpin = (type, conditon) => {
    this.setState({
      [type]: conditon
    })
  };

  handleChange = (name, length) => event => {
    let value = event.target.value;

    if (name === "password") {
      let reg = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{9,}$)");
      let result = reg.test(value);
      if (result) {
        this.setState({
          validatePassword: true,
          [name]: value
        });
      } else {
        this.setState({
          validatePassword: false,
          [name]: value
        });
      }
    } else if (name === "email") {
      let validateEmail = EmailValidator.validate(value.trim());
      if (validateEmail) {
        this.setState({
          validEmail: true,
          [name]: value
        });
      } else {
        this.setState({
          validEmail: false,
          [name]: value
        });
      }
    } else {
      this.setState({
        [name]: value
      });
    }
  };

  dropDownChange = name => (event, {value}) => {
    this.setState({
      userRole: value
    })
  };

  getAllSystemUser = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "user_type": "ALL"
    };
    this.loadSpin("isLoadSysUsers", true);

    axiosTags.get(apiConfig.CORPORATE_SELECT_SYSTEM_USER(this.props.usr_obj.corporateId), {headers: headers})
      .then(response => {
        if (response.data.success) {

          this.setState({
            systemusers_list: response.data.adminUserList
          })
        } else {

          this.setState({
            systemusers_list: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllSystemUser()
        }
      })
      .finally(fin => {
        this.loadSpin("isLoadSysUsers", false);
      });
  };

  clearFeilds = () => {
    this.getAllSystemUser();
    this.setState({
      email: "",
      name: "",
      username: "",
      password: "",
      validatePassword: false,
      validEmail: false,
      mobile: '',
      format_mobile: '',
      valid_mobile: false,
      userRole: ""
    });
  };

  onPhoneNumberChange = (condition, value, object, withdialcode) => {
    value = value.startsWith("00") ? "+" + value.substr(2) : value;
    this.setState({
      valid_mobile: condition,
      format_mobile: withdialcode,
      mobile: value,
    });
  };

  addSystemUser = () => {
    this.state.name.trim() === '' ? common.notifyMessage("Please enter full name") :
      this.state.username.trim() === "" ? common.notifyMessage("Please enter username") :
        !this.state.validEmail ? common.notifyMessage("Please enter valid email") :
          !this.state.valid_mobile ? common.notifyMessage("Invalid mobile number") :
            !this.state.validatePassword ? common.notifyMessage("Password must contain at least 9 characters, including UPPER/LOWERCASE/SPECIAL_CHARACTER and NUMBERS") :
              this.state.userRole === "" ? common.notifyMessage("Please choose USER_ROLE") :
                swal({
                  title: "Are you sure do you want to add new system user?",
                  icon: are_you_sure_icon,
                  closeOnClickOutside: false,
                  buttons: {
                    cancel: 'Cancel',
                    dangerMode: {
                      text: "Yes",
                      value: "action",
                      className: "okay-btn"
                    }
                  },
                }).then((value) => {
                  switch (value) {
                    case "action":
                      this.sendToBackend();
                      break;
                    default:
                      break;
                  }
                });
  };

  sendToBackend = () => {
    const {email, name, username, userRole, password, status, format_mobile} = this.state;
    const obj = {
      "userName": username,
      "password": password,
      "fullName": name,
      "email": email,
      "status": status ? 1 : 0,
      "userRoles": userRole,
      "branchId": [],
      "mobile": format_mobile
    };

    this.props.spinnerHandler(true);

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    axiosTags.put(apiConfig.CORPORATE_SELECT_SYSTEM_USER(this.props.usr_obj.corporateId), obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("System user successfully created - (" + username + ")", 0);
          this.clearFeilds();
          this.getAllSystemUser();
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendToBackend()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  deleteSystemUser = (id, name) => {
    swal({
      title: "Do you want to delete this system user? First please enter \"" + name + "\"",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      content: "input",
    })
      .then((value) => {
        if (value === name) {
          this.deleteSystemUser_(id)
        } else {
          common.warningAlert("Can't delete system user", 1)
        }
      });
  };
  deleteSystemUser_ = (id) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosTags.delete(apiConfig.CORPORATE_SYSTEM_USER_SELECT(id), {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("System user successfully deleted", 0);
          this.clearFeilds();
          this.getAllSystemUser();
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.deleteSystemUser_(id)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };
  updateSystemUser = (obj) => {

    this.setState({
      isUpdate: true,
      recept_data: obj
    })
  };

  viewPassword = () => {
    let i = document.getElementById("password-field");
    if (i.type === "password") {
      i.type = "text"
    } else {
      i.type = "password"
    }
  };

  componentDidMount() {
    this.getAllSystemUser();
    $('input').attr('autocomplete', 'off');
  }

  onHandleSearchMobile = (condition, value, object, withdialcod) => {
    value = value.startsWith("00") ? "+" + value.substr(2) : value;
    condition = util.customMobileValidation(withdialcod.substr(1).replace(/\s/g, ""),condition);

    this.setState({
      valid_search_mobile: condition,
      searchText: withdialcod.substring(1).replace(/\s/g, ""),
      search_mobile: value
    });
  };

  selectedUser = (data) => {

    let userEMail = data.email === null || data.email === "" || data.email === undefined ? "" : data.email;
    let userMobile = data.mobile === null || data.mobile === "" || data.mobile === undefined ? "" : data.mobile;
    let userFName = data.firstName === null || data.firstName === "" || data.firstName === undefined ? "" : data.firstName;
    let userLName = data.lastName === null || data.lastName === "" || data.lastName === undefined ? "" : data.lastName;
    let userValidEMail = false;
    let userValidMobile = false;
    userEMail !== "" ? userValidEMail = true : userValidEMail = false;
    userMobile !== "" ? userValidMobile = true : userValidMobile = false;
    this.setState({
      email: userEMail,
      name: `${userFName === "" ? `` : userFName}${userLName === "" ? `` : ` ${userLName}`}`,
      username: userEMail,
      password: "",
      validatePassword: false,
      validEmail: userValidEMail,
      mobile: userMobile,
      format_mobile: userMobile,
      valid_mobile: userValidMobile
    });

  }

  searchAction = () => {
    let search = this.state.searchText.trim();
    let isValidSearch = false;
    if (this.state.searchType === "NIC") {
      isValidSearch = util.identityValueValidator(search, this.state.searchType);
    } else if (this.state.searchType === "Mobile") {
      this.state.valid_search_mobile ? isValidSearch = true : common.notifyMessage("Please add a valid mobile number.");
    } else if (this.state.searchType === "Email") {
      EmailValidator.validate(search) ? isValidSearch = true : common.notifyMessage("Please add a valid email.");
    } else {
      isValidSearch = true;
    }
    if (isValidSearch) {
      this.clearFeilds()
      this.props.spinnerHandler(true);
      const headers = {"Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")};

      let corporateId = this.props.usr_obj.corporates[0].corporateId;
      axios.get(apiConfig.CORPORATE_VISITOR_IDENTIFY_SEARCH({
        corporateId: corporateId,
        identifyValue: search,
        searchType: this.state.searchType === "Mobile" ? `mobile` : this.state.searchType === "Email" ? 'email' : undefined
      }), {headers: headers})
        .then(response => {
          if (response.data.success) {
            let res = response.data.visitorList;
            if (res === undefined) {
              if (response.data.visitor !== undefined) {
                let visitor = response.data.visitor.visitor;
                this.selectedUser(visitor);
              }
            } else if (res.length !== 0) {
              let user = res[0];
              this.selectedUser(user.visitor);
            }
          } else {
            this.selectedUser({
              email:this.state.searchType === 'Email' ? this.state.searchText : null,
              mobile:this.state.searchType === 'Mobile' ? this.state.search_mobile : null,
              format_mobile:this.state.searchType === 'Mobile' ? this.state.searchText : null,
              username:this.state.searchType === 'Email' ? this.state.searchText : null,
              firstName:null,
              lastName:null,
              validEmail: this.state.searchType === 'Email',
              valid_mobile: this.state.searchType === 'Mobile'
            });
          }
        })
        .catch(async error => {
          let result = await common.checkErrorResponse(error);
        })
        .finally(fin => {
          this.props.spinnerHandler(false);
        })
    }

  };


  render() {
    let {filterStatus, searchOptions} = this.state;
    const rows = [];
    if (this.state.systemusers_list.length !== 0) {
      this.state.systemusers_list.map((row, index) => {
        if (row.userRoles === "RECEPTION" || row.userRoles === "EXTERNAL_RECEPTION" || row.userRoles === "SYS_ADMIN") {
        } else {
          if ((filterStatus === row.userRoles) || filterStatus === "ALL") {
            rows.push(
              {
                name: row.fullName,
                userName: row.userName,
                email: row.email,
                mobile: row.mobile ? row.mobile : "-",
                role: row.userRoles,
                status: row.status === 1 ? "Active" : "Inactive",
                action:
                  <div>
                    <SementicBtn circular icon='edit' onClick={() => this.updateSystemUser(row)}/>
                    <SementicBtn className="cus-btn" circular icon='trash alternate'
                                 onClick={() => this.deleteSystemUser(row.userId, row.userName)}/>
                  </div>
              }
            )
          }
        }
      });
    }
    let columns = this.props.systemUser.columns;
    let table_data = {columns, rows};

    return (
      <Col>
        {
          this.state.isUpdate ?
            <Update data={this.state.recept_data} refreshData={this.getAllSystemUser}
                    closeModal={() => this.setState({isUpdate: false})}/> : null
        }
        <Card>
          <CardHeader>Manage System User</CardHeader>
          <CardBody>
            <Row>
              <Col xs="6" lg={"5"} md={"10"}>
                {
                  this.state.searchType === 'Mobile' ?
                    <div className={"display-inline"} id="mobile-input">
                      <IntlTelInput
                        style={{width: '100%'}}
                        type={"text"}
                        fieldName={"Mobile Number"}
                        value={this.state.search_mobile}
                        containerClassName="intl-tel-input dashboard-intl"
                        inputClassName="form-control"
                        onPhoneNumberChange={this.onHandleSearchMobile}
                        required={true}
                        preferredCountries={['lk']}
                        defaultCountry={"lk"}
                        nationalMode={false}
                        icon='mobile alternate'
                        placeholder="Search here"
                      />
                      <Dropdown
                        style={{borderTopLeftRadius:0, borderBottomLeftRadius:0, display:'flex'}}
                        button basic floating
                        value={this.state.searchType}
                        options={searchOptions}
                        onChange={
                          (e, {value}) => {
                            this.setState({
                              searchType: value, searchText:''
                            })
                          }
                        }
                      />
                    </div> :
                    <Input
                      className="xx"
                      name='searchText'
                      action={
                        <Dropdown
                          button basic floating
                          value={this.state.searchType}
                          options={searchOptions}
                          onChange={
                            (e, {value}) => {
                              this.setState({
                                searchType: value, searchText:''
                              })
                            }
                          }
                        />
                      }
                      style={{width:'100%'}}
                      icon='search'
                      iconPosition='left'
                      placeholder='Search here'
                      value={this.state.searchText}
                      onChange={this.handleChange('searchText')}
                    />
                }
              </Col>
              <Col xs="6" lg={"1"} md={"2"} className={"p-0"}>
                <Button style={{height:'100%'}} color="primary" onClick={this.searchAction}>Search</Button>
              </Col>
              <Col xs="12">
                <hr className={"mb-4"}/>
              </Col>
              <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
                <Row>
                  <Col lg={6}>
                    <Form>
                      <Col className={"none-padding"} lg={12}>
                        <Lbl required>Full Name</Lbl>
                        <LabelInput
                          placeholder={"Full Name"}
                          value={this.state.name}
                          onChange={this.handleChange('name')}
                        />
                      </Col>

                      <Col className={"none-padding"} lg={12}>
                        <Lbl required>User Name</Lbl>
                        <LabelInput
                          placeholder={"User Name"}
                          value={this.state.username}
                          onChange={this.handleChange('username')}
                        />
                      </Col>

                      <Col className={"none-padding"} lg={12}>
                        <Lbl required>Email</Lbl>
                        <LabelInput
                          placeholder={"Email"}
                          value={this.state.email}
                          onChange={this.handleChange('email')}
                        />
                      </Col>
                      <Col className={"none-padding"} lg={12}>
                        <Lbl required >Mobile Number</Lbl>
                        <IntlTelInput
                          type={"text"}
                          fieldName={"Mobile Number"}
                          style={{width: '100%', height: '37px'}}
                          value={this.state.mobile}
                          containerClassName="intl-tel-input dashboard-intl"
                          inputClassName="form-control"
                          onPhoneNumberChange={this.onPhoneNumberChange}
                          required={true}
                          preferredCountries={['lk']}
                          defaultCountry={"lk"}
                          nationalMode={false}
                        />
                      </Col>

                    </Form>
                  </Col>

                  <Col lg={6}>
                    <Form>
                      <Col className={"none-padding"} lg={12}>
                        <Lbl required>Password</Lbl>
                        <Input id={"password-field"} type={"password"}
                               onChange={this.handleChange('password')}
                               value={this.state.password}
                               style={{width: '100%'}}
                               icon={<Icon onMouseUp={() => this.viewPassword(false)}
                                           onMouseDown={() => this.viewPassword(true)} name='eye' circular link/>}
                               placeholder='Password'/>
                      </Col>

                      <Col className={"none-padding"} lg={12}>
                        <Lbl required>Choose USER_ROLES</Lbl>
                        <DrpDwn
                          placeholder={"User Role"}
                          options={DropDownConst.userRoles}
                          value={this.state.userRole}
                          onChange={this.dropDownChange('USER_ROLES')}
                        />
                      </Col>
                      <br/>
                      <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                                checked={this.state.status} onChange={() => this.setState({status: !this.state.status})}
                                toggle
                                label={this.state.status ? 'Active' : 'Inactive'}/>
                    </Form>

                    <Row>
                      <Col className="marginTop" xs={12} sm={12} md={12} lg={12}>
                        <center>
                          <Button
                            className="addBtn"
                            color="primary"
                            onClick={this.addSystemUser}
                          >Add System User</Button>

                          <Tooltip placement="topLeft" title="Clear input fields">
                            <SementicBtn circular icon='refresh' onClick={this.clearFeilds}/>
                          </Tooltip>

                        </center>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <Card>
          <CardHeader>All System Users
          <div className={"align-right filter-dropdown"}>
            <DrpDwn
              placeholder={"USER_ROLES"}
              options={DropDownConst.filterUserRoles} value={filterStatus}
              onChange={(event, {value}) => {this.setState({filterStatus: value})}}
            />
          </div>
          </CardHeader>
          <CardBody>
            <Spin spinning={this.state.isLoadSysUsers} delay={10}
                  indicator={<AntdIcon type="loading" style={{fontSize: 24}} spin={"true"}/>}>
              <MDBDataTable
                searching={true}
                responsive
                responsiveSm
                responsiveMd
                responsiveLg
                responsiveXl
                bordered
                hover
                data={table_data}/>
            </Spin>
          </CardBody>
        </Card>
      </Col>
    );
  }

}


const mapStateToProps = (state) => ({
  table_data: state.COPReceptionReducer.receptionTable_data,
  systemUser: state.COPReceptionReducer.systemUser, //un-use
  // usr obj
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    addReception: (data) => dispatch(actionCreator.addReception(data)),
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
